import { render, staticRenderFns } from "./InputItemOrder.vue?vue&type=template&id=674dc45e&scoped=true"
import script from "./InputItemOrder.vue?vue&type=script&lang=js"
export * from "./InputItemOrder.vue?vue&type=script&lang=js"
import style0 from "./InputItemOrder.vue?vue&type=style&index=0&id=674dc45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674dc45e",
  null
  
)

export default component.exports